module.exports = __webpack_public_path__ + "img/clam_pack.832f21b8.png";